if (!customElements.get('eh-swipe-gallery')) {
  customElements.define('eh-swipe-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.eh-swipe-gallery__track');
      this.slides = Array.from(this.querySelectorAll('.eh-swipe-gallery__slide'));
      if (!this.track || this.slides.length < 2) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.running = this.dataset.autoplay === 'true' && !this.motion.matches;
      this.index = 0;
      this.visible = false;
      this.hovering = false;
      this.counter = this.querySelector('[data-gallery-index]');
      this.pauseButton = this.querySelector('[data-gallery-pause]');
      this.querySelector('[data-gallery-prev]').addEventListener('click', () => { this.pause(); this.move(this.index - 1); }, options);
      this.querySelector('[data-gallery-next]').addEventListener('click', () => { this.pause(); this.move(this.index + 1); }, options);
      this.pauseButton?.addEventListener('click', () => {
        this.running = !this.running;
        this.updateControls();
        this.schedule();
      }, options);
      this.track.addEventListener('pointerdown', () => this.pause(), options);
      this.track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.pause();
        this.move(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / this.track.clientWidth)));
          this.counter.textContent = String(this.index + 1);
        });
      }, { ...options, passive: true });
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'touch') return;
        this.hovering = true;
        this.schedule();
      }, options);
      this.addEventListener('pointerleave', () => { this.hovering = false; this.schedule(); }, options);
      this.addEventListener('focusin', event => { if (event.target !== this.pauseButton) this.pause(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.pause(); }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.25 });
      this.observer.observe(this);
      this.resizeObserver = new ResizeObserver(() => this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' }));
      this.resizeObserver.observe(this.track);
      this.updateControls();
    }
    updateControls() {
      if (this.pauseButton) this.pauseButton.textContent = this.running ? this.dataset.pauseLabel : this.dataset.playLabel;
      this.querySelector('.eh-swipe-gallery__counter').setAttribute('aria-live', this.running ? 'off' : 'polite');
    }
    pause() {
      this.running = false;
      this.updateControls();
      this.schedule();
    }
    move(index) {
      const next = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left: next * this.track.clientWidth, behavior: this.motion.matches ? 'instant' : 'smooth' });
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.running || !this.visible || this.hovering || document.hidden) return;
      this.timer = setTimeout(() => { this.move(this.index + 1); this.schedule(); }, 5500);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      clearTimeout(this.timer);
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
    }
  });
}
